module.exports = __webpack_public_path__ + "img/money-bill.ad83f70a.svg";